import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { sharingInformationService } from '../../../../services/sharingInformationService';
import useChatAvailability from '../useChatAvailability';
import { formatOrderNoteMessage } from '../../../../util/utils';

/**
 * Hook de acciones para OrderNoteMessageMC
 * Encapsula lógica de negocio y efectos secundarios (enviar link, mensaje, PDF, etc)
 */
export default function useOrderNoteActions({ conversation, order: orderData }) {
  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);
  const { isChatClosed } = useChatAvailability({ conversation });

  // Generar link de orden
  const generateOrderLink = useCallback(() => {
    if (isChatClosed) return;

    if (orderData) {
      sharingInformationService.setSubject({
        openSendPaymentLinks: true,
        payload: {
          order: orderData,
          platform: conversation.platform
        }
      });
      sharingInformationService.setSubject({});
    }
  }, [isChatClosed, orderData, conversation.platform]);

  // Enviar orden
  const sendOrder = useCallback(() => {
    if (isChatClosed) return;

    const messageText = formatOrderNoteMessage(orderData, retailer_info, conversation?.platform);
    if (messageText) {
      sharingInformationService.setSubject({
        fillInputChatComponent: true,
        text: messageText
      });
      sharingInformationService.setSubject({});
    }
  }, [isChatClosed, retailer_info, conversation?.platform, orderData]);

  // Generar PDF de orden
  const generateOrderPdf = useCallback(() => {
    if (isChatClosed) {
      return;
    }

    if (orderData) {
      sharingInformationService.setSubject({
        openPdfPaymentLinks: true,
        payload: {
          order: orderData,
          platform: conversation.platform
        }
      });
      sharingInformationService.setSubject({});
    }
  }, [isChatClosed, retailer_info, conversation.platform, orderData]);

  return {
    generateOrderLink,
    sendOrder,
    generateOrderPdf,
  };
}
